module.exports = __webpack_public_path__ + "static/media/14_5.00ea79ac.jpg";